<template>
    <tr class="clickable-row">
		<td><router-link target="_blank" :to="{name:'reservation_detail', params: {reservation_id: transaction.id}}">{{transaction.id}}</router-link></td>
		<td><router-link target="_blank" :to="{name:'reservation_detail', params: {reservation_id: transaction.id}}"><span class="label label-default">{{StringsHelper.getChannel(transaction.channel)}}</span></router-link></td>
		<td><router-link target="_blank" :to="{name:'reservation_detail', params: {reservation_id: transaction.id}}">{{Utils.getDateStringFromISO(transaction.purchase_date)}}</router-link></td>
		<td><router-link target="_blank" :to="{name:'reservation_detail', params: {reservation_id: transaction.id}}"><span v-if="transaction.creator">{{StringsHelper.getOfferta(transaction)}}</span></router-link></td>
		<td><router-link target="_blank" :to="{name:'reservation_detail', params: {reservation_id: transaction.id}}"> <span v-if="transaction.creator">{{transaction.creator.display_name}}</span> </router-link></td>

        <td><router-link target="_blank" :to="{name:'reservation_detail', params: {reservation_id: transaction.id}}"> <span v-if="transaction.document_type">{{StringsHelper.getDocumentType(transaction.document_type)}}</span> </router-link></td>

        <td><router-link target="_blank" :to="{name:'reservation_detail', params: {reservation_id: transaction.id}}"> {{StringsHelper.getPaymentMode(transaction.payment_mode)}}</router-link></td>
		<td><router-link target="_blank" :to="{name:'reservation_detail', params: {reservation_id: transaction.id}}" class="text-right bold">€{{transaction.price_final}}</router-link></td>
		<td><router-link target="_blank" :to="{name:'reservation_detail', params: {reservation_id: transaction.id}}" class="text-right">€{{getFee()}}</router-link></td>
		<td><router-link target="_blank" :to="{name:'reservation_detail', params: {reservation_id: transaction.id}}" class="text-right">€{{transaction.price_net}}</router-link></td>
    </tr>
</template>

<script>
    
    import baseMixin from '@/common/baseMixin'

    export default {
        name: "TransactionRow",
        mixins: [baseMixin],
        props: {
            transaction: {
                type: Object,
                required: true
            }
        },
        methods:{
            getFee(){
                let n = this.transaction.price_final - this.transaction.price_net;
                return n.toFixed(2)
            }
        }
    }
</script>
